import React from "react";
import {
  Button,
  VStack,
  Text,
  Box,
} from "@chakra-ui/react";
import { ConfirmorInfo } from '../../contexts/types';
import { formatLocalDateTime } from '../../utils/utils';

interface Props {
  confirmorInfo: ConfirmorInfo[],
  width: number,
}

/**
 * 確認担当者表示
 * @param props パラメータ
 * @returns
 */
const ConfirmorList: React.FC<Props> = (props: Props) => {
  return (
    <VStack>
      {Array.isArray(props.confirmorInfo) && props.confirmorInfo.map((name, index) => {
        // フロントエンドの既存関数でUTC→JSTに変換
        const localDateTime = formatLocalDateTime(name.confirmTime);

        return (
          <Button as="div"
            key={index}
            ml="10px"
            mt="3px"
            mb="-3px"
            pl="3px"
            pr="3px"
            textAlign="center"
            variant={name.isConfirmor ? 'outline' : 'ghost'}
            width={`${props.width}px`}
            isTruncated
            border="none"
            cursor="default"
            _hover={{ bg: name.isConfirmor ? 'gray.50' : 'transparent' }}
          >
            <Box width="100%" overflow="hidden">
              <Text isTruncated fontSize="inherit">
                {name.employeeName}
              </Text>
              {name.confirmTime && (
                <Text
                  isTruncated
                  fontSize="10px"
                  color="gray.500"
                  mt="-2px"
                >
                  {localDateTime}
                </Text>
              )}
            </Box>
          </Button>
        );
      })}
    </VStack>
  );
}

export default ConfirmorList;